import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-542b54b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "header",
      class: _normalizeClass({ light: !_ctx.darkMode })
    }, [
      _createElementVNode("div", {
        id: "name",
        class: _normalizeClass(["title1", { light: !_ctx.darkMode }])
      }, _toDisplayString(_ctx.$t("menu.name")), 3),
      _createElementVNode("div", {
        id: "job",
        class: _normalizeClass(["title2", { light: !_ctx.darkMode }])
      }, _toDisplayString(_ctx.$t("menu.job")), 3)
    ], 2),
    _createElementVNode("nav", {
      id: "step-list",
      class: _normalizeClass({ light: !_ctx.darkMode })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeList, (route, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: index,
          to: route.path,
          class: _normalizeClass(["step-container title2", { light: !_ctx.darkMode }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("menu." + route.name)), 1)
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ], 2)
  ]))
}